export default (store, router) => {
  router.beforeEach((to, from, next) => {
    const locationPath = window.location.hash.split('#')[1]
    if (locationPath !== to.fullPath) {
      V8.Router.Push(to.fullPath)
      return
    }
    next()
  })
  router.afterEach(async (to, from) => {
    let currentMenuCache = false
    if (V8) {
      const res = await V8.FormEngine.GetTableData({
        FormEngineKey: 'sys_menu',
        _Where: [
          {
            Name: 'Url',
            Value: to.fullPath,
            Type: '=',
          },
        ],
      })
      if (res && res.Code === 1 && res.Data.length > 0) {
        currentMenuCache = res.Data[res.Data.length - 1].MicroiServiceCache === 'True'
      }
    }
    // 缓存：为兼容当前产品场景1.默认所有saas模块不缓存 2.配置keepAlive为true或者低代码配置缓存
    // 存在缓存条件
    const isExistCache = (app.cacheInstance && app.cacheInstance.cache) || (app.fullScreenCacheInstance && app.fullScreenCacheInstance.cache)
    if (!isExistCache) {
      return
    }
    const clearCachePath = to.fullPath
    if (to.meta.keepAlive || currentMenuCache) {
      return
    }
    if (app.cacheInstance && app.cacheInstance.cache) {
      _.forIn(app.cacheInstance.cache, (vNode, key, caches) => {
      if (key === clearCachePath) {
        // key值相同将缓存移除
        delete caches[key]
      }
    })
    }
    if (app.fullScreenCacheInstance && app.fullScreenCacheInstance.cache) {
      _.forIn(app.fullScreenCacheInstance.cache, (vNode, key, caches) => {
        if (key === clearCachePath) {
          // key值相同将缓存移除
          delete caches[key]
        }
      })
    }
    
  })
}